import { Component } from 'src/utils';
import template from './inactive.html';
import resetPwdImg from './../../../images/reset-pass-2.png';
import confirmImg from './../../../images/tick-sent.png';


@Component({
  controllerAs: 'inactive',
  template
})

export default class InactiveContainer {
  static $inject = [
    '$scope',
    '$stateParams',
    '$ngRedux',
    'authActions',
    'authService'
  ];

  constructor($scope, $stateParams, $ngRedux, authActions, authService) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$ngRedux = $ngRedux;
    this.$stateParams = $stateParams;
    this.authActions = authActions;
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
    this.confirmImg = confirmImg;
    this.storeName = $stateParams.storeName;
    this.userInactive = true;
    this.sendmail = true;

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      auth: state.auth
    };
  }

  // activate() {
  //   this.authService.activateUser(this.email)
  //     .then(() => this.activationsuccess = true)
  //     .catch(err => {
  //       console.log(err);
  //       if (err.data.errorCode === 624 ) {
  //         this.alreadyUser = 'You have already successfully registered using this Activation.';
  //       }
  //       else {
  //         this.activationerror = err.data.message;
  //       }
  //     });
  // }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    this.activationerror = null;
    this.error = null;
    if (this.sendmail) {
      this.authService.activateUser(this.email)
        .then(success => {
          this.userInactive = false;
          this.success = success.data.message;
        })
        .catch(err => {
          this.userInactive = false;
          this.error = err.data.message;
        });
        this.sendmail = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/inactive/inactive.js